import clsx from "clsx";
import ComponentHeading from "components/ComponentHeading/ComponentHeading";
import typography from "components/typography";
import { componentAccordionFragment, componentHeadingFragment, assetFragment } from "contentful/fragments";
import { getFragmentData } from "contentful/gql";
import { ComponentFaqFragment } from "contentful/gql/graphql";
import ArrowSmDown_16px from "icons/ArrowSmDown_16px";
import richTextParser, { RichText } from "utils/richTextParser";
import Image from "next/image";

const Accordion = ({ faqCollection, faqHeading, faqHeadingIsLeftAligned, isForBlogPost }: ComponentFaqFragment) => {
  const heading = getFragmentData(componentHeadingFragment, faqHeading);
  return (
    <div className="mx-auto max-w-screen-lg">
      <div className="mb-4">
        {heading && <ComponentHeading {...heading} alignment={faqHeadingIsLeftAligned ? "left" : "center"} />}
      </div>
      <div>
        {faqCollection?.items?.map((item) => {
          const faq = getFragmentData(componentAccordionFragment, item);
          const image = faq?.image ? getFragmentData(assetFragment, faq.image) : null;
          return (
            <details key={faq?.sys.id} className="group/faq mb-xs mt-md" open={faq?.defaultOpen ?? false}>
              <summary className="flex flex-col">
                <div
                  className={clsx(
                    typography.heading.cardHeading,
                    "flex cursor-pointer items-start justify-between font-medium transition-colors",
                    isForBlogPost
                      ? "text-primary-dark-800 group-open/faq:text-primary-dark-800 dark:text-primary-neutral-50"
                      : "text-primary-dark-800 group-open/faq:text-primary-light-500 dark:text-primary-neutral-50",
                  )}
                >
                  <h3 className={clsx("mb-2xs pr-xs", isForBlogPost && "text-3xl font-bold")}>{faq?.heading}</h3>

                  {!isForBlogPost && (
                    <span className="h-6 w-6 flex-shrink-0 rounded-full bg-primary-light-500/10 p-4xs text-primary-light-500 transition duration-300 group-open/faq:-rotate-180 group-open/faq:bg-primary-light-500 group-open/faq:text-primary-neutral-50">
                      <ArrowSmDown_16px strokewidth="1.5px" />
                    </span>
                  )}
                </div>
                <hr
                  className={clsx(
                    "transition-colors",
                    isForBlogPost
                      ? "text-primary-dark-800/20 group-open/faq:text-primary-dark-800/50"
                      : "text-primary-dark-800/20 group-open/faq:text-primary-light-500/50",
                  )}
                />
              </summary>
              <div className="mb-[30px] mt-sm w-full md:w-[90%] [&_p]:text-base">
                {richTextParser(faq?.body as RichText)}
                {image?.url && (
                  <Image
                    src={image.url}
                    alt={image.title || faq?.heading || "FAQ Image"}
                    width={image.width || 800}
                    height={image.height || 400}
                    className="my-xs rounded-xl"
                  />
                )}
              </div>
            </details>
          );
        })}
      </div>
    </div>
  );
};

export default Accordion;
